module.exports = __webpack_public_path__ + "44bc83424347a76cc138db6a5e819bd2.svg";